import { FilterWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('Filter')
export class FilterConnectorProvider extends ConnectorProvider<FilterWorkflowNode> {}
